var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.$t(_vm.title),"items":_vm.items}}),_c('ConsolidatedChart',{attrs:{"events":_vm.consolidatedData,"states":_vm.cptStates,"total":_vm.totalDevices,"loaderData":_vm.loaderData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }